const SURFSIDE_APP_ID = 'gapcommerce';

export { SURFSIDE_APP_ID };
